(function () {
  'use strict';

  var TOAST_DURATION = 3000;
  var SUCCESS_DURATION = 1500;
  var STOCK_DURATION = 2200;
  var toastState = null;

  function cartEndpoint(path) {
    return path;
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    try {
      return amount.toLocaleString('ro-RO', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' lei';
    } catch (error) {
      return amount.toFixed(2) + ' lei';
    }
  }

  function getCart() {
    return fetch(cartEndpoint('/cart.js'), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }

  function refreshCartHeader(cart) {
    if (!cart) return;
    document.querySelectorAll('.rx-cart__n').forEach(function (element) {
      element.textContent = cart.item_count;
    });
    document.querySelectorAll('.rx-cart__t').forEach(function (element) {
      element.textContent = formatMoney(cart.total_price);
    });
  }

  function isAddToCartForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.matches('[data-rx-atc]')) return true;
    var action = form.getAttribute('action') || '';
    return /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(action);
  }

  function findSubmitButton(form, submitter) {
    if (submitter && submitter.matches('button, input[type="submit"]')) return submitter;
    return form.querySelector('button[type="submit"], input[type="submit"], button:not([type])');
  }

  function saveButton(button) {
    if (!button) return null;
    if (button._rxFeedbackTimer) window.clearTimeout(button._rxFeedbackTimer);
    return {
      html: button.innerHTML,
      value: button.value,
      disabled: button.disabled
    };
  }

  function startLoading(button, saved) {
    if (!button || !saved) return;
    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
  }

  function restoreButton(button, saved) {
    if (!button || !saved) return;
    if (button._rxFeedbackTimer) window.clearTimeout(button._rxFeedbackTimer);
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    button.innerHTML = saved.html;
    button.value = saved.value;
    button.disabled = saved.disabled;
    button._rxFeedbackTimer = null;
  }

  function showButtonStatus(button, saved, label, duration) {
    if (!button || !saved) return;
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    button.disabled = true;
    if (button.tagName === 'INPUT') button.value = label;
    else button.textContent = label;
    button._rxFeedbackTimer = window.setTimeout(function () {
      restoreButton(button, saved);
    }, duration);
  }

  function productImageFromForm(form) {
    var scope = form.closest('.rx-card, .rx-pdp, product-card, product-information') || form.parentElement;
    var image = scope && scope.querySelector('.rx-card__media img, .rx-pdp__main img, img');
    return image ? image.currentSrc || image.src : '';
  }

  function retinaImageUrl(source) {
    if (!source) return '';
    try {
      var url = new URL(source, window.location.origin);
      url.searchParams.set('width', '112');
      return url.toString();
    } catch (error) {
      return source;
    }
  }

  function dismissToast(immediate) {
    if (!toastState) return;
    window.clearTimeout(toastState.hideTimer);
    window.clearTimeout(toastState.removeTimer);
    var node = toastState.node;
    toastState = null;
    if (immediate) {
      node.remove();
      return;
    }
    node.classList.remove('is-visible');
    node.classList.add('is-leaving');
    window.setTimeout(function () {
      node.remove();
    }, 300);
  }

  function showToast(details) {
    dismissToast(true);

    var toast = document.createElement('aside');
    toast.className = 'rx-cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');

    var content = document.createElement('div');
    content.className = 'rx-cart-toast__content';

    var image = document.createElement('img');
    image.className = 'rx-cart-toast__thumb';
    image.width = 56;
    image.height = 56;
    image.alt = '';
    if (details.image) image.src = retinaImageUrl(details.image);
    else image.hidden = true;

    var body = document.createElement('div');
    body.className = 'rx-cart-toast__body';

    var heading = document.createElement('p');
    heading.className = 'rx-cart-toast__title';
    heading.textContent = 'Produs adăugat în coș';

    var description = document.createElement('p');
    description.className = 'rx-cart-toast__description';
    description.appendChild(document.createTextNode(details.title + ' '));
    var price = document.createElement('span');
    price.className = 'rx-cart-toast__price';
    price.textContent = formatMoney(details.price);
    description.appendChild(price);

    var actions = document.createElement('div');
    actions.className = 'rx-cart-toast__actions';

    var cartLink = document.createElement('a');
    cartLink.className = 'rx-cart-toast__cart';
    cartLink.href = cartEndpoint('/cart');
    cartLink.textContent = 'Vezi coșul';

    var undo = document.createElement('button');
    undo.className = 'rx-cart-toast__undo';
    undo.type = 'button';
    undo.textContent = 'Anulează';

    var close = document.createElement('button');
    close.className = 'rx-cart-toast__close';
    close.type = 'button';
    close.setAttribute('aria-label', 'Închide notificarea');
    close.textContent = '×';

    var progress = document.createElement('span');
    progress.className = 'rx-cart-toast__progress';
    progress.setAttribute('aria-hidden', 'true');

    actions.appendChild(cartLink);
    actions.appendChild(undo);
    body.appendChild(heading);
    body.appendChild(description);
    body.appendChild(actions);
    content.appendChild(image);
    content.appendChild(body);
    toast.appendChild(content);
    toast.appendChild(close);
    toast.appendChild(progress);
    document.body.appendChild(toast);

    toastState = {
      node: toast,
      hideTimer: window.setTimeout(function () {
        dismissToast(false);
      }, TOAST_DURATION),
      removeTimer: null
    };

    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    close.addEventListener('click', function () {
      dismissToast(false);
    });

    undo.addEventListener('click', function () {
      if (undo.disabled) return;
      window.clearTimeout(toastState && toastState.hideTimer);
      progress.style.animationPlayState = 'paused';
      undo.disabled = true;
      undo.textContent = 'Se anulează…';

      fetch(cartEndpoint('/cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: details.lineKey || details.variantId,
          quantity: details.previousQuantity
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('Undo request failed');
        return response.json();
      }).then(function (cart) {
        refreshCartHeader(cart);
        dismissToast(false);
      }).catch(function () {
        undo.disabled = false;
        undo.textContent = 'Reîncearcă';
      });
    });
  }

  function stockError(message) {
    var error = new Error(message || 'Maximum stock is already in cart');
    error.isStockLimit = true;
    return error;
  }

  function addToCart(form) {
    var previousCart;
    var addSucceeded = false;
    var formData = new FormData(form);
    var variantId = formData.get('id');

    return getCart().then(function (cart) {
      previousCart = cart;
      return fetch(cartEndpoint('/cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
    }).then(function (response) {
      if (response.status === 422) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          throw stockError(payload.description || payload.message);
        });
      }
      if (!response.ok) throw new Error('Add to cart request failed');
      addSucceeded = true;
      return response.text();
    }).then(function (text) {
      var payload = {};
      try { payload = JSON.parse(text); } catch (error) { payload = {}; }
      var added = payload.items && payload.items.length ? payload.items[0] : payload;

      return getCart().catch(function () { return null; }).then(function (currentCart) {
        var addedVariantId = added.variant_id || added.id || variantId;
        var currentItem = currentCart && currentCart.items.find(function (item) {
          if (added.key) return item.key === added.key;
          return String(item.variant_id) === String(addedVariantId);
        });
        var previousItem = previousCart && previousCart.items.find(function (item) {
          if (added.key) return item.key === added.key;
          return String(item.variant_id) === String(addedVariantId);
        });

        if (currentCart) refreshCartHeader(currentCart);

        return {
          title: added.product_title || (currentItem && currentItem.product_title) || added.title || 'Produs',
          price: added.final_price || added.price || (currentItem && currentItem.final_price) || 0,
          image: (added.featured_image && added.featured_image.url) || added.image || (currentItem && currentItem.image) || productImageFromForm(form),
          lineKey: added.key || (currentItem && currentItem.key),
          variantId: addedVariantId,
          previousQuantity: previousItem ? previousItem.quantity : 0
        };
      });
    }).catch(function (error) {
      error.addSucceeded = addSucceeded;
      throw error;
    });
  }

  function classicSubmit(form, button, saved) {
    restoreButton(button, saved);
    form.dataset.rxCartFeedbackBypass = 'true';
    HTMLFormElement.prototype.submit.call(form);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isAddToCartForm(form)) return;
    if (form.dataset.rxCartFeedbackBypass === 'true') {
      delete form.dataset.rxCartFeedbackBypass;
      return;
    }

    var button = findSubmitButton(form, event.submitter);
    if (button && (button.disabled || button.classList.contains('is-loading'))) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    dismissToast(true);
    var saved = saveButton(button);
    startLoading(button, saved);

    addToCart(form).then(function (details) {
      showButtonStatus(button, saved, 'Adăugat', SUCCESS_DURATION);
      showToast(details);
    }).catch(function (error) {
      if (error.isStockLimit) {
        showButtonStatus(button, saved, 'Stoc maxim în coș', STOCK_DURATION);
        return;
      }
      if (error.addSucceeded) {
        showButtonStatus(button, saved, 'Adăugat', SUCCESS_DURATION);
        return;
      }
      classicSubmit(form, button, saved);
    });
  }, true);
})();
